<template>
    <div>
        <span v-if="isFormatted">
            {{formattedValue}}
        </span>
        <span v-else>{{fieldValue}}</span>
    </div>
</template>

<script>
    export default {
        name: 'NumberRenderer',
        props: ['field', 'document'],
        computed: {
            fieldValue() {
                return this.document[this.field.index]
            },
            formattedValue() {
                if(this.field.metadata.format === 'percentage' && this.document[this.field.index]) {
                    let number = Number(this.document[this.field.index])
                    return number.toLocaleString(undefined,{style: 'percent', minimumFractionDigits:1});
                }

                return this.document[this.field.index]
            },
            isFormatted() {
                return this.field.metadata && this.field.metadata.format !== 'none'
            }
        },
        data () {
            return {
                model: webase.model
            }
        }
    }
</script>

<style>

</style>
